import React, { FC } from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { MenuStackParamList } from './types';
import {
  Sports,
  CourtDetail,
  EvenList,
  EshopCategoryPage,
  EshopHomePage,
  EventDetail,
  EshopDetailPage,
  CheckoutPage,
  Menu,
  Notices,
  NoticeDetail,
  GrillRoom,
  DinningMenu,
  DinningPromotion,
  PrivateFunction,
  ClubNews,
  ClubNewDetail,
  ServicesForms,
  Survey,
  Feedback,
  ReciprocalClubs,
} from '../screens';
import EShopSubCategoryPage from '../screens/EShop/EshopSubCategoryPage/EshopSubCategoryPage';
import { DinningPromotionDetail } from '../screens/DinningPromotionDetail';

const Stack = createNativeStackNavigator<MenuStackParamList>();
const MenuStack: FC = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        contentStyle: {
          backgroundColor: 'white',
          flex: 1,
        },
        headerShown: false,
      }}
    >
      <Stack.Screen name="Menu" component={Menu} />
      <Stack.Screen name="Sports" component={Sports} />
      <Stack.Screen name="CourtDetail" component={CourtDetail} />
      <Stack.Screen name="EventList" component={EvenList} />
      <Stack.Screen name="EventDetail" component={EventDetail} />
      <Stack.Screen name="Notices" component={Notices} />
      <Stack.Screen name="NoticeDetail" component={NoticeDetail} />
      <Stack.Screen name="EShopHomePage" component={EshopHomePage} />
      <Stack.Screen name="EShopCategoryPage" component={EshopCategoryPage} />
      <Stack.Screen name="EShopDetailPage" component={EshopDetailPage} />
      <Stack.Screen name="EShopCheckout" component={CheckoutPage} />
      <Stack.Screen
        name="EShopSubCategoryPage"
        component={EShopSubCategoryPage}
      />
      <Stack.Screen name="DinningMenu" component={DinningMenu} />
      <Stack.Screen name="DinningPromotion" component={DinningPromotion} />
      <Stack.Screen
        name="DinningPromotionDetail"
        component={DinningPromotionDetail}
      />
      <Stack.Screen name="GrillRoom" component={GrillRoom} />
      <Stack.Screen name="PrivateFunction" component={PrivateFunction} />
      <Stack.Screen name="ClubNews" component={ClubNews} />
      <Stack.Screen name="ClubNewDetail" component={ClubNewDetail} />
      <Stack.Screen name="ServiceForm" component={ServicesForms} />
      <Stack.Screen name="Survey" component={Survey} />
      <Stack.Screen name="Feedback" component={Feedback} />
      <Stack.Screen name="ReciprocalClubs" component={ReciprocalClubs} />
    </Stack.Navigator>
  );
};

export default MenuStack;
